<div
  *ngIf="isEditable || description || model.internalNote"
  class="description-edit-row font-newJuneBold"
  [class.toggle-open]="visible">
  <ng-container *ngIf="!(hideNote || showNoteBelow) && !showHideDescriptionOnly">
    <div
      class="flex mr-4"
      *ngIf="!visible && isEditable">
      <div
        class="flex items-center pointer"
        (click)="showDescription($event)">
        <mat-icon class="material-symbols-rounded orange">{{ description ? 'visibility' : 'edit_note' }}</mat-icon>
        <span>{{
          description || model.internalNote
            ? description
              ? 'Show Description and Internal note'
              : 'Add Description'
            : 'Add Description and Internal note'
        }}</span>
      </div>
    </div>
    <div
      class="flex mr-4"
      *ngIf="!visible && !isEditable && (description || model.internalNote)">
      <div
        class="flex items-center pointer"
        (click)="showDescription($event)">
        <mat-icon class="material-symbols-rounded orange">visibility</mat-icon>
        <span>{{
          description
            ? model.internalNote
              ? 'Show Description and Internal note'
              : 'Show Description'
            : 'Show Internal note'
        }}</span>
      </div>
    </div>
    <div
      class="flex mr-4"
      *ngIf="visible && isEditable">
      <div
        class="flex items-center pointer"
        (click)="hideDescription($event)">
        <mat-icon class="material-symbols-rounded orange">visibility_off</mat-icon>
        <span>Hide Description and Internal note</span>
      </div>
    </div>
    <div
      class="flex mr-4"
      *ngIf="visible && !isEditable && (description || model.internalNote)">
      <div
        class="flex items-center pointer"
        (click)="hideDescription($event)">
        <mat-icon class="material-symbols-rounded orange">visibility_off</mat-icon>
        <span>{{
          description
            ? model.internalNote
              ? 'Hide Description and Internal note'
              : 'Hide Description'
            : 'Hide Internal note'
        }}</span>
      </div>
    </div>
    <div
      class="flex mr-4"
      *ngIf="!editingDescription && isEditable && (description || extraDescriptionActive)">
      <div
        class="flex items-center pointer"
        (click)="editDescription($event)">
        <mat-icon class="material-symbols-rounded orange fill">mode_edit</mat-icon>
        <span>Edit Description</span>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="(hideNote || showNoteBelow) && !showHideDescriptionOnly">
    <div
      class="flex mr-4"
      *ngIf="!visible && !description">
      <div
        class="flex items-center pointer"
        (click)="showDescription($event)">
        <mat-icon class="material-symbols-rounded orange">edit_note</mat-icon>
        <span>Add Description{{ descriptionRequired ? '*' : '' }}</span>
      </div>
    </div>
    <div
      class="flex mr-4"
      *ngIf="!editingDescription && isEditable && (description || extraDescriptionActive)">
      <div
        class="flex items-center pointer"
        (click)="editDescription($event)">
        <mat-icon class="material-symbols-rounded orange fill">mode_edit</mat-icon>
        <span>Edit Description</span>
      </div>
    </div>
    <span
      *ngIf="descriptionRequired && descriptionDirty && !description"
      class="error"
      >This is required</span
    >
  </ng-container>
  <ng-container *ngIf="showHideDescriptionOnly">
    <div
      class="flex mr-4"
      *ngIf="!visible">
      <div
        class="flex items-center pointer"
        (click)="showDescription($event)">
        <mat-icon class="material-symbols-rounded orange">visibility</mat-icon>
        <span>Show Description</span>
      </div>
    </div>
    <div
      class="flex mr-4"
      *ngIf="visible">
      <div
        class="flex items-center pointer"
        (click)="hideDescription($event)">
        <mat-icon class="material-symbols-rounded orange">visibility_off</mat-icon>
        <span>Hide Description</span>
      </div>
    </div>
  </ng-container>
  <div
    class="flex mr-4"
    *ngIf="
      visible &&
      commentingService.globalUseCommentable(commentable) &&
      commentingService.globalShowInputCommentable() &&
      description
    ">
    <div
      class="flex items-center pointer"
      (click)="toggleCommenting()">
      <mat-icon
        *ngIf="commentable?.comments?.length == 0"
        class="material-symbols-rounded orange"
        >add_comment</mat-icon
      >
      <div
        class="comments-number"
        *ngIf="commentable?.comments?.length > 0">
        {{ commentable?.comments?.length }}
      </div>
      <span>{{ commenting ? 'Finish commenting' : 'Add Comments' }}</span>
    </div>
  </div>
  <div
    class="flex mr-4"
    *ngIf="
      visible && commentingService.globalUseCommentable(commentable) && !commentingService.globalShowInputCommentable()
    ">
    <div class="flex items-center">
      <div
        class="comments-number"
        *ngIf="commentable?.comments?.length > 0">
        {{ commentable?.comments?.length }}
      </div>
      <span>Comments</span>
    </div>
  </div>
</div>
<div
  class="description-choice"
  *ngIf="extraDescription && visible"
  [has-setting]="ApplicationSetting.SCOPE__EXTRA_DESCRIPTION_FIELD">
  <div
    class="highlight"
    [ngClass]="extraDescriptionActive ? 'translate-100' : 'translate-0'"></div>
  <button
    (click)="showMainDescription()"
    [ngClass]="{ active: !extraDescriptionActive }">
    Main description
  </button>
  <button
    (click)="showExtraDescription()"
    [ngClass]="{ active: extraDescriptionActive }">
    Extra description
  </button>
</div>
<!-- Show extra description when setting is disabled but extraDescription has content -->
<div
  class="extra-description-readonly"
  *ngIf="
    extraDescription &&
    visible &&
    !extraDescriptionActive &&
    model.extraDescription &&
    !loggedInUser?.company.hasApplicationSetting(ApplicationSetting.SCOPE__EXTRA_DESCRIPTION_FIELD)
  ">
  <div class="extra-description-label">Extra Description:</div>
  <div
    class="extra-description-content"
    [innerHTML]="model.extraDescription | safe: true"></div>
</div>
<div
  class="flex cursor-auto gap-8 my-2"
  [class.flex-col]="showNoteBelow"
  [class.flex-row]="!showNoteBelow"
  [hidden]="!visible"
  (mouseout)="setDisableDragging(false)"
  (mouseover)="setDisableDragging(true)">
  <div
    #descriptionEditor
    class="description-editor resizable"
    (mousedown)="$event.stopPropagation()"
    [class.w-full]="showNoteBelow"
    [class.editing]="editingDescription"
    [class.description-editor__text]="!editingDescription"
    [ngStyle]="{ height: getInternalNoteHeight() }"
    data-nodrag>
    <commentable
      [c-if]="
        commenting ||
        (commentingService.globalUseCommentable(commentable) && !commentingService.globalShowInputCommentable())
      "
      [c-entity]="model"
      [c-key]="'description'"
      (onSetCommentable)="setCommentable($event)"
      data-nodrag
      *ngIf="!editingDescription && (isEditable || description)"
      class="description-text">
      <div [innerHTML]="description | safe: true"></div>
    </commentable>
    <ng-container *ngIf="editingDescription">
      <ckeditor
        [editor]="Editor"
        [ngModel]="description"
        [disabled]="disabled"
        (ngModelChange)="description = $event; descriptionDirty = true"></ckeditor>

      <div class="flex justify-end mt-1.5 items-center">
        <button
          mat-button
          class="ml-8"
          [disabled]="disabled"
          (click)="cancelDescription()">
          <span class="tracking-normal">Cancel</span>
        </button>
        <button
          class="confirm ml-4"
          [disabled]="disabled"
          *ngIf="isEditable"
          (click)="saveDescription()">
          <span class="tracking-normal">Save</span>
        </button>
      </div>
    </ng-container>
  </div>

  <div
    *ngIf="!hideNote && (isEditable || model.internalNote)"
    class="description-editor"
    [class.w-full]="showNoteBelow">
    <div class="internal-note flex flex-col">
      <div class="internal-note-label">Internal Note</div>

      <mat-form-field
        *ngIf="isEditable"
        class="w-full">
        <textarea
          matInput
          name="internalNote"
          cols="100"
          rows="1"
          placeholder="Click here to add an internal note"
          [disabled]="(model.internalNote && !editingNote) || disabled || showHideDescriptionOnly"
          [maxLength]="10000"
          [(ngModel)]="internalNote"
          (focus)="editNote($event)"
          (mousedown)="$event.stopPropagation()">
        </textarea>
      </mat-form-field>
      <div
        class="text-m-top-10"
        *ngIf="!isEditable && model.internalNote">
        {{ model.internalNote }}
      </div>

      <div>
        <span
          class="save-button"
          *ngIf="editingNote && isEditable"
          (click)="saveNote()"
          >Save</span
        >
        <span
          class="orange right bold pointer"
          *ngIf="!editingNote && model.internalNote && isEditable && !showHideDescriptionOnly"
          (click)="editNote($event)"
          >Edit Note</span
        >
        <span
          class="cancel-button"
          *ngIf="editingNote"
          (click)="cancelNote()"
          >Cancel</span
        >
      </div>
    </div>
  </div>
</div>
